import { AppDispatch } from 'app/store';
import { setConflictErrorOrigin,setNameInConflict } from 'common/components/EditDrawer/editDrawerSlice';
import { ApiStatusCodes } from 'common/constants/apiStatusCodes';
import { Operations } from 'common/types/TypeDefs';
import { ConflictErrorOrigin } from 'common/utils/LicenseAclEntriesErrorHelpers';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

export const DEFAULT_ERROR_MESSAGE = ' If you continue to encounter problems, please contact IT Support.';

export const handleEditDrawerError = (
    operation: Operations.Create | Operations.Edit | Operations.Link,
    code: number,
    type: string,
    dispatch: AppDispatch,
    enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
    errorOrigin?: ConflictErrorOrigin,
) => {
    if (code === ApiStatusCodes.CONFLICT) {
        dispatch(setNameInConflict(true));
        if (errorOrigin) {
            dispatch(setConflictErrorOrigin(errorOrigin));
        }
        return;
    }

    const operationNameMap = {
        [Operations.Create]: 'creating',
        [Operations.Edit]:   'editing',
        [Operations.Link]:   'linking',
    };

    enqueueSnackbar(
        `There was an error while ${operationNameMap[operation]} the ${type}.` +
        DEFAULT_ERROR_MESSAGE,
        { variant: 'error' }
    );
};

export const logApiErrorsExcept404 = (code: number, entityName: string) => {
    if (code === ApiStatusCodes.NOT_FOUND) {
        return;
    }
    console.error(`There was an error while retrieving ${entityName} data`);
};

export const handleListFetchError = (code: number, type: string, enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey) => {
    if (code === ApiStatusCodes.NOT_FOUND) {
        return;
    }
    enqueueSnackbar(
        `There was an error while retrieving ${type} rows.` +
        DEFAULT_ERROR_MESSAGE,
        { variant: 'error' }
    );
};

export const handleExportDataFetchError = (code: number, type: string, enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey) => {
    if (code === ApiStatusCodes.NOT_FOUND) {
        return;
    }
    enqueueSnackbar(
        `There was an error while retrieving ${type} data for export.` +
        DEFAULT_ERROR_MESSAGE,
        { variant: 'error' }
    );
};

export const handleDeleteDialogError = (type: string, enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey, code?: number) => {
    if (code === ApiStatusCodes.CONFLICT) {
        enqueueSnackbar(`The ${type} has child objects which need to be removed prior to deleting the ${type}.`, { variant: 'error' });
        return;
    }
    enqueueSnackbar(
        `There was an error while deleting this ${type}.` +
        DEFAULT_ERROR_MESSAGE,
        { variant: 'error' }
    );
};
